import {useCallback, useState} from 'react';

/**
 * One accordion item open at a time: clicking the open one closes it, clicking another switches to it.
 * `initial` is the item open on first render (none by default, as in the FAQ sections).
 */
export const useOpenItem = (initial: number | false = false) => {
    const [open, setOpen] = useState<number | false>(initial);
    const toggle = useCallback((index: number) => {
        setOpen((current) => (current === index ? false : index));
    }, []);
    return [open, toggle] as const;
};
